import { useTranslation } from 'i18n';
import { guideImages } from '../../data';
import { Complete } from '../Complete/Complete';
import { GuideImage } from '../GuideImage/GuideImage';

export const PartThree = () => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideImage src={guideImages.baleComplete} alt={t('backlog.helpGuides.common.completeAlt')} height="fixed" />
      <Complete />
    </>
  );
};
